<button
  khA11yActionButton
  class="kh-button-reset ChatIconFloating"
  [khA11yLabel]="'A11Y_LABEL.OPEN_CHAT' | translate"
  (click)="viewChat()">
  <kh-img path="chat-button.png" alt="" khA11yHidden></kh-img>
</button>
